import React, { useEffect, useState } from "react";
import { getBillingStatus } from "./api/OrganizationClient";

export default function BillingSuccessPage() {
  const [message, setMessage] = useState("We are securely activating your subscription.");
  const [subMessage, setSubMessage] = useState("This usually takes only a few seconds.");
  const [isActivated, setIsActivated] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let attempts = 0;

    const pollBillingStatus = async () => {
      attempts += 1;

      try {
        const status = await getBillingStatus();

        if (status.is_paid) {
          if (cancelled) return;

          setIsActivated(true);
          setMessage("Your subscription is active.");
          setSubMessage("Redirecting you to your workspace...");

          setTimeout(() => {
            window.location.href = "/";
          }, 4500);

          return;
        }
      } catch {
        // keep polling
      }

      if (!cancelled && attempts < 14) {
        setTimeout(pollBillingStatus, 2500);
      } else if (!cancelled) {
        setMessage("Payment received.");
        setSubMessage("Your subscription is still syncing. Please refresh your workspace in a moment.");
      }
    };

    pollBillingStatus();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f8fafc 0%, #eef2f7 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 32,
        color: "#111827",
        fontFamily:
          "Inter, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 620,
          background: "#ffffff",
          border: "1px solid #e5e7eb",
          borderRadius: 24,
          boxShadow: "0 24px 70px rgba(15, 23, 42, 0.12)",
          padding: "44px 42px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            margin: "0 auto 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: isActivated ? "#ecfdf5" : "#eff6ff",
            border: isActivated ? "1px solid #a7f3d0" : "1px solid #bfdbfe",
            fontSize: 34,
            fontWeight: 700,
            color: isActivated ? "#059669" : "#2563eb",
          }}
        >
          {isActivated ? "✓" : "•"}
        </div>

        <p
          style={{
            margin: "0 0 10px",
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            color: "#64748b",
          }}
        >
          ZEITGEIST BILLING
        </p>

        <h1
          style={{
            margin: "0 0 14px",
            fontSize: 32,
            lineHeight: 1.2,
            letterSpacing: "-0.02em",
          }}
        >
          {isActivated ? "Subscription activated" : "Thank you for subscribing"}
        </h1>

        <p
          style={{
            margin: "0 auto",
            maxWidth: 460,
            fontSize: 16,
            lineHeight: 1.6,
            color: "#475569",
          }}
        >
          {message}
        </p>

        <p
          style={{
            margin: "10px auto 0",
            maxWidth: 460,
            fontSize: 14,
            color: "#64748b",
          }}
        >
          {subMessage}
        </p>

        {!isActivated && (
          <div
            style={{
              margin: "30px auto 0",
              width: "100%",
              maxWidth: 320,
              height: 6,
              borderRadius: 999,
              overflow: "hidden",
              background: "#e5e7eb",
            }}
          >
            <div
              style={{
                width: "60%",
                height: "100%",
                background: "#2563eb",
              }}
            />
          </div>
        )}

        <div
          style={{
            marginTop: 32,
            paddingTop: 20,
            borderTop: "1px solid #e5e7eb",
            fontSize: 12,
            color: "#64748b",
          }}
        >
          Secure payment processed by Stripe · Syncing your workspace access
        </div>
      </div>
    </div>
  );
}